import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    page: {
        display: 'flex',
        justifyContent: 'center',
        padding: tokens.spacingHorizontalSNudge,
        width: '100%',
        boxSizing: 'border-box',
    },
    form: {
        width: '100%',
        maxWidth: '100%',
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusMedium,
        padding: tokens.spacingVerticalXXXL,
        boxShadow: tokens.shadow4,
        boxSizing: 'border-box',
        minWidth: 0,
    },
    title: {
        fontSize: tokens.fontSizeHero800,
        fontWeight: tokens.fontWeightSemibold,
        marginTop: '0',
        marginBottom: tokens.spacingVerticalXXXL,
        wordBreak: 'break-word',
    },
    twoColumnRowWithDivider: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) max-content minmax(0, 1fr)',
        gap: tokens.spacingHorizontalXXXL,
        marginTop: tokens.spacingVerticalXXXL,
        marginBottom: tokens.spacingVerticalXXXL,
        alignItems: 'stretch',
        '@media (max-width: 900px)': {
            gridTemplateColumns: '1fr',
            gap: tokens.spacingVerticalL,
        },
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
        minWidth: 0,
        maxWidth: '100%',
    },
    sectionFullWidth: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
        marginTop: tokens.spacingVerticalXXXL,
        marginBottom: tokens.spacingVerticalXXXL,
        minWidth: 0,
        maxWidth: '100%',
        overflowX: 'auto',
    },
    sectionTitle: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightSemibold,
        marginTop: '0',
        marginBottom: tokens.spacingVerticalM,
        wordBreak: 'break-word',
    },
    subRow: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
        gap: tokens.spacingHorizontalL,
        '@media (max-width: 640px)': {
            gridTemplateColumns: '1fr',
            gap: tokens.spacingVerticalM,
        },
    },
    dropzone: {
        border: `2px dashed ${tokens.colorNeutralStroke1}`,
        borderRadius: tokens.borderRadiusMedium,
        padding: tokens.spacingVerticalL,
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: tokens.colorNeutralBackground1,
        transitionProperty: 'border-color',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        flex: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        maxWidth: '100%',
        ':hover': {
            ...shorthands.borderColor(tokens.colorBrandStroke1),
        },
    },
    dropzoneActive: {
        border: `2px solid ${tokens.colorBrandStroke1}`,
        borderRadius: tokens.borderRadiusMedium,
        padding: tokens.spacingVerticalL,
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: tokens.colorNeutralBackground2,
        flex: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        maxWidth: '100%',
    },
    dropzoneContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: tokens.spacingVerticalM,
        width: '100%',
        minWidth: 0,
    },
    fileList: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalS,
        width: '100%',
        minWidth: 0,
    },
    fileItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: tokens.spacingVerticalS,
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusSmall,
        minWidth: 0,
        gap: tokens.spacingHorizontalS,
    },
    fileName: {
        fontSize: tokens.fontSizeBase300,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: '1',
        minWidth: 0,
    },
    divider: {
        marginLeft: `calc(-1 * ${tokens.spacingVerticalXXXL})`,
        marginRight: `calc(-1 * ${tokens.spacingVerticalXXXL})`,
        width: `calc(100% + 2 * ${tokens.spacingVerticalXXXL})`,
    },
    verticalDivider: {
        alignSelf: 'stretch',
        '@media (max-width: 900px)': {
            display: 'none',
        },
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: tokens.spacingHorizontalM,
        marginTop: tokens.spacingVerticalXXL,
        paddingTop: tokens.spacingVerticalL,
        flexWrap: 'wrap',
        '@media (max-width: 640px)': {
            flexDirection: 'column',
            '& > *': {
                width: '100%',
            },
        },
    },
    comboboxCustomValue: {
        backgroundColor: tokens.colorStatusWarningBackground2,
    },
    dialogBackdrop: {
        backgroundColor: 'transparent',
    },
});
